import React from 'react';

const ProjectLedger = () => {
  return (
    <div className="max-w-7xl mx-auto px-6 my-24">
      {/* Protocol Header */}
      <div className="flex items-center gap-6 mb-12">
        <div className="h-[1px] w-24 bg-amber-800"></div>
        <div className="tech-label">PROTOCOL_STATUS: GOVERNANCE_ACTIVE</div>
      </div>

      {/* Protocol Display Area */}
      <div className="blueprint-grid border border-stone-200 p-12 bg-stone-50/50">
        <div className="grid md:grid-cols-2 gap-16">
          
          {/* Left Column: Forensic Focus */}
          <div className="space-y-6">
            <h3 className="text-2xl font-serif italic text-stone-950">Architectural Stewardship</h3>
            <p className="text-sm text-stone-600 font-light leading-relaxed">
              We monitor asset integrity through a lens of forensic technical governance. Every project input is treated as a strategic variable in your infrastructure's 15-year lifecycle.
            </p>
          </div>

          {/* Right Column: Active Pipeline */}
          <div className="space-y-4">
            <div className="flex justify-between items-center border-b border-stone-200 pb-2">
              <span className="text-[10px] font-black uppercase text-stone-400">Consultation Pipeline</span>
              <span className="text-[10px] font-mono text-amber-800">STREAM_LIVE</span>
            </div>
            
            <div className="space-y-2">
              <div className="flex justify-between text-[11px] font-mono">
                <span className="text-stone-500">INFRASTRUCTURE_AUDIT</span>
                <span className="text-stone-900 font-bold">READY</span>
              </div>
              <div className="flex justify-between text-[11px] font-mono">
                <span className="text-stone-500">TECHNICAL_DIRECTIVE</span>
                <span className="text-stone-900 font-bold">PENDING_REVIEW</span>
              </div>
              <div className="flex justify-between text-[11px] font-mono">
                <span className="text-stone-500">ASSET_VALUATION_LOG</span>
                <span className="text-stone-900 font-bold">LOCKED</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectLedger;